import React from "react";
import {
  Clock,
  Award,
  Zap,
  BadgeIndianRupee,
  Settings,
  MapPin,
} from "lucide-react";

const WhyChooseUs = () => {
  const reasons = [
    {
      id: "01",
      title: "Same Day Service",
      desc: "Back in action in 24h",
      icon: <Clock />,
    },
    {
      id: "02",
      title: "Certified Techs",
      desc: "Industry-best specialists",
      icon: <Award />,
    },
    {
      id: "03",
      title: "30 Min Response",
      desc: "Ultra-fast dispatch",
      icon: <Zap />,
    },
    {
      id: "04",
      title: "Affordable Rates",
      desc: "Honest, upfront pricing",
      icon: <BadgeIndianRupee />,
    },
    {
      id: "05",
      title: "Genuine Parts",
      desc: "100% original components",
      icon: <Settings />,
    },
    {
      id: "06",
      title: "At Your Door",
      desc: "Workshop at your home",
      icon: <MapPin />,
    },
  ];

  return (
    <section className="py-24 bg-[#F9FAFB]">
      <div className="container mx-auto px-6 lg:px-16">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-16 gap-4">
          {/* FIXED TITLE */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-slate-900 tracking-tighter uppercase whitespace-nowrap">
            Why <span className="text-[#0F52BA]">Choose Us</span>
          </h2>

          <p className="text-slate-400 font-bold tracking-widest text-xs uppercase text-center md:text-right">
            Elite Service Standard
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200 rounded-3xl overflow-hidden">
          {reasons.map((item, idx) => (
            <div
              key={idx}
              className="group bg-white p-10 relative overflow-hidden transition-all duration-500 hover:bg-[#eef4ff]"
            >
              <span className="absolute -right-4 -bottom-4 text-9xl font-black text-slate-50 group-hover:text-blue-100 transition-colors">
                {item.id}
              </span>

              <div className="relative z-10">
                <div className="flex items-center gap-4 mb-4">
                  <div className="text-slate-400 group-hover:text-[#0F52BA] transition-colors duration-300">
                    {React.cloneElement(item.icon, {
                      size: 28,
                      strokeWidth: 1.5,
                    })}
                  </div>

                  <h3 className="text-xl font-bold text-slate-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                </div>

                <p className="text-slate-500 font-medium group-hover:text-slate-700 transition-colors">
                  {item.desc}
                </p>
              </div>

              <div className="absolute top-0 left-0 w-0 h-1 bg-[#FF6B00] group-hover:w-full transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
